import { useState } from 'react'
import type { Member, Task } from '@domain/state.ts'
import { es } from '../strings/es.ts'

/**
 * Que el repaso de mates cuente como misión del día.
 *
 * Es el único ajuste del juego, y a propósito: jugar está siempre abierto y no se
 * raciona. Lo que se decide aquí es si además paga, y cuánto — con lo cual el
 * juego no trae una economía nueva, sino que entra en la que ya hay.
 *
 * Se valida sola al terminar la sesión. Nadie tiene que comprobar unas tablas, y
 * el niño no se queda esperando a que pase un adulto por delante de la tablet.
 */
export function JuegoSetting({
  member,
  mision,
  onCreate,
  onRemove,
}: {
  member: Member
  mision: Task | undefined
  onCreate: (coins: number) => void
  onRemove: (taskId: Task['id']) => void
}) {
  const [coins, setCoins] = useState(10)
  const palabra = member.coinWord ?? es.today.coins

  return (
    <>
      <h3 className="text-muted mt-8 mb-1 text-xs font-bold tracking-[0.1em] uppercase">
        {es.config.juego}
      </h3>
      <p className="text-muted mt-0 mb-3 text-sm">{es.config.juegoHelp}</p>

      {mision ? (
        <div className="flex flex-wrap items-center gap-3">
          <p className="m-0 font-bold">
            {es.config.juegoActive(mision.rewards[mision.rung].coins, palabra)}
          </p>
          <button
            type="button"
            className="border-rule rounded border px-4 font-bold"
            onClick={() => {
              onRemove(mision.id)
            }}
          >
            {es.config.juegoRemove}
          </button>
        </div>
      ) : (
        <div className="flex flex-wrap items-end gap-3">
          <label className="text-sm font-bold">
            <span className="mb-1 block">{es.config.juegoCoins}</span>
            <input
              type="number"
              min={0}
              max={99}
              value={coins}
              className="border-rule w-24 rounded border px-3 py-2 tabular-nums"
              onChange={(e) => {
                setCoins(Math.max(0, Math.min(99, Number(e.target.value))))
              }}
            />
          </label>
          <button
            type="button"
            className="bg-teal rounded px-5 font-bold text-white"
            onClick={() => {
              onCreate(coins)
            }}
          >
            {es.config.juegoCreate}
          </button>
        </div>
      )}
    </>
  )
}
